import React from 'react';
import './MessageBubble.css';
import Button from '../Button/Button';

// Helper function to detect payment links
const isPaymentLink = (url) => {
    return url.includes('mercury-t2.phonepe.com/transact') || 
           url.includes('mercury.phonepe.com/transact') ||
           url.includes('phonepe.com/transact') ||
           url.includes('phonepe.com') ||
           url.includes('mercury.phonepe.com');
};

// Function to detect if message is an order tracking response
const isOrderTrackingResponse = (text) => {
    return text.includes('Order #') && 
           (text.includes('Tracking Details:') || text.includes('Tracking Numbers:') || text.includes('Order Summary:'));
};

// Simple function to format order tracking responses
function formatOrderTracking(text) {
    if (!isOrderTrackingResponse(text)) {
        return null;
    }

    // Simply preserve line breaks and make links clickable
    const lines = text.split('\n');
    const formattedLines = lines.map((line, index) => {
        const trimmedLine = line.trim();
        
        // If line is empty, return a line break
        if (!trimmedLine) {
            return <br key={`br-${index}`} />;
        }
        
        // For all other lines, just make links clickable and preserve the text
        return (
            <div key={`line-${index}`} style={{ marginBottom: '4px' }}>
                {linkify(trimmedLine)}
            </div>
        );
    });

    return (
        <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4' }}>
            {formattedLines}
        </div>
    );
}

// Improved function to convert URLs in text to clickable links or buttons
function linkify(text) {
    if (!text) return '';
    const urlRegex = /((https?:\/\/|www\.)[\w\-._~:/?#[\]@!$&'()*+,;=%]+|[\w\-._~:/?#[\]@!$&'()*+,;=%]+\.(com|net|org|io|ai|co|in|me|shop|xyz|dev|app)(\b|\/)[^\s]*)/gi;
    const parts = [];
    let lastIndex = 0;
    let match;
    while ((match = urlRegex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }
        let url = match[0];
        let href = url;
        if (!/^https?:\/\//i.test(href)) {
            href = 'https://' + href;
        }
        
        // Check if this is a payment link
        if (isPaymentLink(href)) {
            parts.push(
                <Button
                    key={href + match.index}
                    onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
                    variant="primary"
                    size="small"
                    className="payment-button"
                >
                    <span className="payment-icon">💳</span>
                    Pay Now
                </Button>
            );
        } else {
            parts.push(
                <a
                    key={href + match.index}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#8ecbff', textDecoration: 'underline', wordBreak: 'break-all' }}
                >
                    {url}
                </a>
            );
        }
        lastIndex = match.index + url.length;
    }
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }
    return parts;
}

const MessageBubble = ({ message, timestamp, sender, type, isFirstMessage = false }) => {
    console.log('MessageBubble props:', { message, timestamp, sender, type, isFirstMessage });
    
    const bubbleClass = `message-bubble ${sender.toLowerCase()} ${type === 'prompt' ? 'prompt' : ''} ${isFirstMessage ? 'no-animation' : ''}`;
    const rowClass = `message-bubble-row ${sender.toLowerCase()}`;
    const isAI = sender.toLowerCase() === 'ai';
    const senderLabel = isAI ? 'Ria' : 'You';
    
    return (
        <div className={rowClass}>
            {isAI && (
                <div className="message-avatar">
                    <img src="/logo.png" alt="Ria Logo" />
                </div>
            )}
            <div className={bubbleClass}>
                <span className="bubble-sender-label">{senderLabel}</span>
                <div className="message-content">
                    {formatOrderTracking(message) || linkify(message)}
                </div>
                <div className="message-timestamp">{timestamp}</div>
            </div>
        </div>
    );
};

export default MessageBubble;